
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '#ll-body' ).toggleClass( 'is-open' );
        $( '.primary-nav' ).slideToggle();
      } );

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).slideToggle();
      } );

      const updateBannerHeight = () => {
        if ( $( '.nav__cta-banner' ).length > 0 ) {
          const ctaBannerHeight = $( '.nav__cta-banner' ).outerHeight();
          document.documentElement.style.setProperty( '--ctaBannerHeight', `${ctaBannerHeight}px` );
        }
      };

      updateBannerHeight();

      $( document ).on( 'click', '.js-init-video', function( e ) {
        e.preventDefault();
        $.magnificPopup.open( {
          items: {
            src: $( this ).attr( 'href' ),
          },
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      if ( window.matchMedia( '(max-width: 1024px)' ).matches ) {
        $( '.children-item__children.is-open-parent' ).trigger( 'click' );
      }

      function handleLargeChange( event ) {
        updateBannerHeight();
        if ( !event.matches && ( $( '.children-item__children.is-open-parent' ).length === 0 ) ) {
          $( '.children-item__children[data-toggle-is-active]' ).trigger( 'click' );
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(max-width: 1024px)' );
      mobileSize.addEventListener( 'change', handleLargeChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      if ( $( '.mec-breadcrumbs' ).length > 0 ) {
        const updateBreadCrumbHeight = function() {
          const $breadCrumbHeight = $( '.mec-breadcrumbs' ).outerHeight();
          $( ':root' ).css( '--liftedMecBreadCrumbHeight', $breadCrumbHeight + 'px' );
        };
        updateBreadCrumbHeight();
        const throttledUpdateBreadCrumbHeight = new app.components.common.Throttle( updateBreadCrumbHeight, 250 );
        $( window ).on( 'resize', function() {
          throttledUpdateBreadCrumbHeight.run();
        } );
      }

      /* Primary button */
      $( '.btn-primary, .btn-primary-white, .single_add_to_cart_button, .ll-wocommerce .button, .button.wc-forward, .restore-item, .woocommerce-form-coupon .form-row-last button, .lost_reset_password .woocommerce-Button, .woocommerce-MyAccount-content a.button, .woocommerce button.button, .bag_sidebar-link a' )
          .on( 'mouseenter', function( e ) {
            const parentOffset = $( this ).offset();
            const relX = e.pageX - parentOffset.left;
            const relY = e.pageY - parentOffset.top;
            $( this )[0].style.setProperty( '--primaryTop', `${relY}px` );
            $( this )[0].style.setProperty( '--primaryLeft', `${relX}px` );
          } )
          .on( 'mouseout', function( e ) {
            const parentOffset = $( this ).offset();
            const relX = e.pageX - parentOffset.left;
            const relY = e.pageY - parentOffset.top;
            $( this )[0].style.setProperty( '--primaryTop', `${relY}px` );
            $( this )[0].style.setProperty( '--primaryLeft', `${relX}px` );
          } );
      $( document ).on( 'submit', '.form-skin', function() {
        // Disable submit button
        $( this ).find( 'button[type="submit"]' ).prop( 'disabled', true ).css( 'opacity', 0.2 );
      } );
    },
    finalize: function() {
    },
    Throttle: class Throttle {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.throttlePause = false;
      }
      run() {
        if ( this.throttlePause ) return;
        this.throttlePause = true; // Set throttle pause state for this instance
        setTimeout( () => {
          this.callback();
          this.throttlePause = false; // Reset throttle pause state after callback execution
        }, this.time );
      }
    },
    Debounce: class Debounce {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.debounceTimer;
      }
      run() {
        window.clearTimeout( this.debounceTimer );
        this.debounceTimer = window.setTimeout( this.callback, this.time );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
